import { useMemo } from 'react';
import { Box, Flex } from '@televet/kibble-ui/chakra';
import { Text, Button, Avatar, useBreakpoint } from '@televet/kibble-ui';
import { getFlowUpsellUrl } from '../flowUpsellUrl';

interface OttoFlowUpsellCTAProps {
  title?: string;
  description?: string;
  learnMoreText?: string;
}

export function OttoFlowUpsellCTA({
  title = 'Let Otto Flow handle this for you',
  description = 'Upgrade to Otto Flow to automate the actions described above — personalized outreach, self-service booking, intelligent follow-ups, and full performance tracking. No manual effort required.',
  learnMoreText = 'Learn more about Otto Flow',
}: OttoFlowUpsellCTAProps) {
  const breakpoint = useBreakpoint();
  const flowUrl = getFlowUpsellUrl();

  const isMobile = useMemo(() => ['base', 'sm'].includes(breakpoint), [breakpoint]);

  return (
    <Box borderRadius="md" background="background.gradientFull" padding={4}>
      <Flex gap={3} align="flex-start">
        <Avatar iconName="star" size={isMobile ? 'xs' : 'sm'} variant="accent" />
        <Flex direction="column" gap={2} flex="1">
          <Box>
            <Text fontWeight="semibold" fontSize="sm" variant="default">
              {title}
            </Text>
            <Text fontSize="xs" variant="subtle">
              {description}
            </Text>
          </Box>
          <Flex gap={{ base: 2, md: 3 }} align="center" mt={1}>
            <Button
              data-testid="otto-flow-upsell-cta-learn-more-button"
              size="sm"
              variant="ghost"
              onClick={() => window.open(flowUrl, '_blank', 'noopener,noreferrer')}
              iconName="externalLink"
              iconPosition="right"
            >
              {learnMoreText}
            </Button>
          </Flex>
        </Flex>
      </Flex>
    </Box>
  );
}
